import React from "react";
import AddNewSalePlatformIntegrationDialog from "src/components/AddNewSalePlatformIntegrationDialog";
import { etsyRequestAuthorizationCode } from "src/apiService/modules/etsy";
import { useLoadingBackdrop } from "src/contexts/LoadingBackdropContext";

export interface AddEtsyIntegrationDialogProps {
  open: boolean;
  onClose: () => void;
}

function AddEtsyIntegrationDialog({
  open,
  onClose,
}: AddEtsyIntegrationDialogProps) {
  const backdrop = useLoadingBackdrop();

  return (
    <AddNewSalePlatformIntegrationDialog
      open={open}
      onClose={onClose}
      platformName="Etsy"
      onConnect={async (bankAccountId) => {
        const authResponse = await etsyRequestAuthorizationCode({
          bankAccountId,
        });
        backdrop.current.show();
        window.location.href = authResponse.data.etsyURL;
      }}
    />
  );
}

export default AddEtsyIntegrationDialog;
